<template>
  <div class="inputBoxWrap">
    <label>{{item.label}}<br/>
      <select
        v-model.trim="value"
        v-on:focus="eventFocus"
        v-on:blur="eventBlur"
        :name="refs"
        :placeholder="item.placeholder"
      >
        <option :key="index"
                :value="option.value"
                v-for="(option,index) in inputFilter">
          {{option.name}}
        </option>
      </select>
      <p class="errorMsg" v-if="statusVuex[refs].ShowError">{{errorMsg}}</p>
    </label>

  </div>
</template>

<script>
  import DataForInput from '@/store/Form/longFormOptions';
  import {mapGetters, mapState} from 'vuex'
  export default {
    name: "fmSelect",
    data: function () {
      return {
        item: DataForInput[this.refs],

      }
    },
    props: {
      refs: {
        type: String,
        default: 'null'
      },
    },
    methods: {
      eventFocus(){
        this.$palantir.trackInputFocus(this.refs);
        this.$store.dispatch('errorShow', {
          target: this.refs,
          value: false,
        });
      },
      eventBlur(){
        this.$palantir.trackInputBlur(this.refs,this.valueVuex[this.refs]);
      }
    },
    computed: {
      inputFilter: function(){
        let out = [];
        if (this.refVuex.length > 0) {
            let refArray = this.refVuex.filter(key => key.fieldName == this.refs);
            if (refArray.length > 0) {
              out = refArray[0].fieldValues
            }
        }
        return out;
      },
      status: function () {
        return this.statusVuex[this.refs].code;
      },
      errorMsg: function () {
        return this.statusVuex[this.refs].msg;
      },
      showErrorMessage: function () {
        return this.status != 0 && this.isTimeToShowError;
      },
      colorBorder: function () {
        switch (this.status) {
          case 1:
            return 'border-color:#b7b7b7;';
          case 0:
            return 'border-color:green;';
          default:
            return 'border-color:red;';
        }
      },
      value: {
        get() {
          return this.valueVuex[this.refs]
        },
        set(value) {
          let utiputi = {
            target: this.refs,
            value: value
          };
          this.$store.dispatch('saveSendData', utiputi);
        }
      },
      errorStatus: function () {
        return false
      },
      ...mapGetters(['getTargetFieldValue']),
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData,
        refVuex: state => state.Form.ref,
      })
    }
  }
</script>

<style scoped>
  .inputBoxWrap{background: #F6F8F7;padding: 3vw 3vw 2vw;border-radius: 1px;margin-bottom: 0.9vw;}
  .inputBoxWrap label{display: block;color:#869A95;font-size:  4vw;}
  .inputBoxWrap select{display: block;color:#222721;font-size: 5vw;padding: 1.6vw 0
  ;background: transparent;border: 0;width: 100%;}
  .inputBoxWrap p{display: block;}

  @media screen and (min-width: 760px) {
    .inputBoxWrap{margin-bottom: 0.6vw;padding: 1.5vw 1.1vw 1vw;}
    .inputBoxWrap label{font-size: 1.1vw;}
    .inputBoxWrap select{font-size: 1.3vw;padding: 0.2vw 0;}
    .inputBoxWrap p{}
  }
  @media screen and (min-width: 1140px) {
    .inputBoxWrap{padding: 17px 13px 11px;margin-bottom: 7px;}
    .inputBoxWrap label{font-size:  12px;}
    .inputBoxWrap select{font-size: 14px;padding: 2px 0;}
    .inputBoxWrap p{}
  }
</style>
